import { useEffect, useState } from 'react';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

const compute = (): Breakpoint => {
  if (typeof window === 'undefined') return 'desktop';
  const w = window.innerWidth;
  if (w < 720) return 'mobile';
  if (w < 1080) return 'tablet';
  return 'desktop';
};

export const useBreakpoint = (): Breakpoint => {
  const [bp, setBp] = useState<Breakpoint>(compute);
  useEffect(() => {
    let raf = 0;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setBp(compute()));
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      cancelAnimationFrame(raf);
    };
  }, []);
  return bp;
};

export const isNarrow = (bp: Breakpoint) => bp === 'mobile' || bp === 'tablet';
